// extracted by mini-css-extract-plugin
export default {"header":"qTPYp4DUt_","headerText":"VGThin9S69"};